import type { SalesOrderStatus } from '@/lib/api/sales-order-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

export const STATUS_LABELS: Record<SalesOrderStatus, () => string> = {
    draft: m.status_order_draft,
    new: m.status_order_new,
    awaiting_packaging: m.await_status_badge,
    confirmed: m.status_order_confirmed,
    stock_out: m.status_order_stock_out,
    ready_to_deliver: m.status_order_ready_to_deliver,
    in_delivery: m.status_order_in_delivery,
    delivered: m.status_order_delivered,
    delivery_failed: m.status_order_delivery_failed,
    returned: m.status_order_returned,
    cancelled: m.status_order_cancelled,
}

// Mỗi trạng thái một tông màu riêng theo ý nghĩa tên (nền nhạt + chữ đậm cùng
// tông → tương phản AA↑, dễ đọc). Có bản dark tách riêng. Tách hết các cặp từng
// trùng: xác nhận↔xuất kho, mới↔đã giao, chờ đóng gói↔chờ giao↔đang giao, thất bại↔huỷ.
export const STATUS_COLORS: Record<SalesOrderStatus, string> = {
    draft: 'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-200',
    new: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
    confirmed:
        'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-200',
    awaiting_packaging:
        'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
    stock_out:
        'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-200',
    ready_to_deliver:
        'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
    in_delivery:
        'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-200',
    delivered:
        'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
    delivery_failed:
        'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
    returned:
        'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200',
    cancelled:
        'bg-zinc-200 text-zinc-700 dark:bg-zinc-700/60 dark:text-zinc-200',
}

interface Props {
    status: SalesOrderStatus
}

export function OrderStatusBadge({ status }: Props) {
    // Trạng thái lạ vẫn hiện nguyên văn (dev nhìn ra ngay backend trả gì), nhưng
    // trạng thái rỗng thì fallback không còn chữ nào — vẽ ra chỉ là viên pill
    // trống. Xem PaymentStatusBadge, cùng khuôn.
    if (!status?.trim()) return null

    return (
        <Badge className={STATUS_COLORS[status]}>
            {STATUS_LABELS[status]?.() ?? status}
        </Badge>
    )
}
